import { PropertyProps } from "../hooks/useFetchProperties";
import { createContext } from "react";
const PropertiesContext = createContext<PropertyProps[]>([]);
export default PropertiesContext;
